import React from 'react';

function LeaguePortraitCard({ league }) {
	if (!league) {
		return null;
	}

	// Debug logging
	console.log('LeaguePortraitCard - league data:', league);
	console.log(
		'LeaguePortraitCard - commissioner_name:',
		league.commissioner_name
	);

	return (
		<div className="mb-6">
			<div className="border border-gray-300 dark:border-dark-border rounded-xl shadow-lg bg-white dark:bg-dark-card">
				<div className="px-4 sm:px-6 lg:px-8 py-6">
					{/* League details */}
					<div className="flex items-center flex-col lg:flex-row">
						{/* League image */}
						{league.league_image_url ? (
							<img
								className="h-44 lg:h-48 xl:h-64 rounded-xl my-4 lg:mr-8"
								src={league.league_image_url}
								alt={`${league.league_name || 'League'} logo`}
								onError={(e) => {
									e.target.style.display = 'none';
								}}
							/>
						) : (
							<div className="h-44 w-44 lg:h-48 lg:w-48 xl:h-64 xl:w-64 rounded-xl my-4 lg:mr-8 bg-gray-200 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 flex items-center justify-center">
								<i className="fas fa-trophy text-6xl lg:text-7xl xl:text-8xl text-gray-400 dark:text-gray-500" />
							</div>
						)}
						<div className="text-center lg:text-left lg:pt-14">
							{/* League name */}
							<div className="flex items-center justify-center lg:justify-start mb-2">
								<h1 className="text-3xl lg:text-4xl font-bold dark:text-dark-text">
									{league.league_name || 'League'}
								</h1>
							</div>

							{/* Commissioner */}
							{league.commissioner_name && (
								<div className="items-center sm:items-start mb-4 lg:mb-2">
									<div className="text-center lg:text-left">
										<p className="text-lg font text-gray-500 dark:text-dark-text">
											Commissioned by {league.commissioner_name}
										</p>
									</div>
								</div>
							)}

							<hr className="mt-4 block lg:hidden" />

							{/* League metadata */}
							<div className="flex flex-wrap items-start text-base text-gray-500 dark:text-dark-text mt-6 lg:mt-2 pb-4 lg:pb-8">
								{league.platform && (
									<div className="flex items-center mr-6 mb-2">
										<span className="font-bold uppercase">Platform</span>
										<span className="ml-2 capitalize">{league.platform}</span>
									</div>
								)}
								{league.format && (
									<div className="flex items-center mr-6 mb-2">
										<span className="font-bold uppercase">Format</span>
										<span className="ml-2">{league.format}</span>
									</div>
								)}
								{league.scoring && (
									<div className="flex items-center mr-6 mb-2">
										<span className="font-bold uppercase">Scoring</span>
										<span className="ml-2">{league.scoring}</span>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default LeaguePortraitCard;
